async function enableMocking() {
	// Only enable mocking in development and browser environment if the ENABLE_MSW_MOCK environment variable is set to true
	if (
		process.env.NEXT_PUBLIC_ENVIRONMENT !== 'development' ||
		typeof window === 'undefined' ||
		process.env.NEXT_PUBLIC_ENABLE_MSW_MOCK !== 'true' ||
		process.env.NEXT_PUBLIC_PUBLISHED !== 'false'
	) {
		return;
	}

	const { worker } = await import('./browser');

	// `worker.start()` returns a Promise that resolves
	// once the Service Worker is up and ready to intercept requests.
	return worker.start({
		onUnhandledRequest: 'bypass',
	});
}

enableMocking();
